<template>
  <div
    class="alert"
    :class="{ [`alert--${alert}`] : alert }"
    v-if="alert !== null"
  >
    <div class="alert__content">
      <div class="alert__icon">
        <AlertSVG />
      </div>

      <p class="alert__text" ref="is_past_due">
        <b>Sua conta está suspensa :(</b><br />
        <span>Atualize seus dados de pagamento. <router-link :to="{ name: 'support' }">Precisando de ajuda?</router-link></span>
      </p>

      <p class="alert__text" ref="is_pending">
        <b>Assinatura aguardando pagamento</b><br />
        <span>Assim que seu pagamento for compensado sua assinatura será ativada automaticamente</span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AlertSVG from '@/components/svg/AlarmSVG'

export default {
  components: {
    AlertSVG,
  },

  data: () => ({
    types: [
      'is_past_due',
      'is_pending'
    ]
  }),

  computed: {
    ...mapGetters('subscription', ['subscription']),

    alert () {
      for (let i in this.types) {
        if (this.subscription[this.types[i]]) return this.types[i]
      }
      return null
    }
  },

  watch: {
    alert: {
      handler (alert) {
        if (!alert) return
        
        this.$nextTick(() => {
          this.types.forEach(alertType => this.$refs[alertType].style.display = (alertType == alert) ? 'block' : 'none')
        })
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss">
  @keyframes blink {
    0% { opacity: 1 }
    25% { opacity: 0.2 }
    50% { opacity: 1 }
    75% { opacity: 0.2 }
    100% { opacity: 1 }
  }

  @mixin alert ($p, $color) {
    border-color: lighten($color, 25%);
    background: lighten($color, 35%);
    color: $color;

    #{$p}__text a { color: $color }
    #{$p}__icon { background: $color }
  }

  .alert {
    $p: &;
    
    margin: 0;
    padding: 15px 15px;
    border-radius: 0;
    border-bottom: 2px solid black;



    &__content {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__text {
      display: none;

      a {
        font-weight: 700;
        text-decoration: underline;
      }
    }

    &__icon {
      animation-name: blink;
      animation-duration: 1s;   
      animation-timing-function: ease-in-out;
      animation-delay: 1.5s;

      padding: 10px;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;


      svg { width: 30px; fill: #fff } 
    }

    &--is_pending { @include alert($p, #e28e29)}
    &--is_past_due { @include alert($p, #ff3e2a)}
  }
</style>